import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-dark-950 flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-dark-900 items-center justify-center p-12">
        <div className="max-w-md text-center">
          {/* Logo placeholder */}
          <div className="w-24 h-24 mx-auto mb-8 bg-dark-800 rounded-2xl flex items-center justify-center">
            <img src="https://admin.questsim.com/Images/UltisimLogo.png" alt="Application Logo" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-4">TeamSync</h1>
          <p className="text-dark-400 text-lg">
            Your company portal for time tracking, task management, and team collaboration.
          </p>
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-400">24/7</div>
              <div className="text-sm text-dark-500">Access</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-400">100%</div>
              <div className="text-sm text-dark-500">Secure</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-amber-400">Fast</div>
              <div className="text-sm text-dark-500">Updates</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden mb-8 text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-dark-800 rounded-xl flex items-center justify-center">
              <img src="https://admin.questsim.com/Images/UltisimLogo.png" alt="Application Logo" />
            </div>
            <h1 className="text-xl font-bold text-white">TeamSync</h1>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
